import React, { memo } from 'react';
import Spinner from '../Spinner';
import styles from './style.module.css';
const Button = (props) => {
  const {
    label,
    type,
    width,
    url,
    testId,
    showSpinner = false,
    ...rest
  } = props;
  if (showSpinner) {
    return (
      <button
        type="button"
        style={{ width: width }}
        className={`${styles.btn} ${styles.btn_blur}`}>
        <Spinner />
      </button>
    );
  }
  return (
    <>
      <button
        {...rest}
        type={type}
        style={{ width: width }}
        className={styles.btn}>
        {label}
      </button>
    </>
  );
};

export default memo(Button);
